interface WizardStepLabelProps {
  step: number;
  isUkiyo: boolean;
  ukiyoKanji?: string[];
  ukiyoLabels?: string[];
  standardLabels?: string[];
}

const DEFAULT_UKIYO_KANJI = ['問', '心'];
const DEFAULT_UKIYO_LABELS = ['Who are you?', 'Your interests'];
const DEFAULT_STANDARD_LABELS = ['Welcome', 'Interests'];

export function WizardStepLabel({
  step,
  isUkiyo,
  ukiyoKanji = DEFAULT_UKIYO_KANJI,
  ukiyoLabels = DEFAULT_UKIYO_LABELS,
  standardLabels = DEFAULT_STANDARD_LABELS,
}: WizardStepLabelProps) {
  if (isUkiyo) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 0, marginBottom: 12 }}>
        <div style={{
          border: '1.5px solid #1A1410', borderRight: 'none',
          padding: '3px 9px', background: '#1B5C8A',
        }}>
          <span style={{
            fontFamily: "'Noto Serif JP', serif", fontSize: 12,
            fontWeight: 700, color: '#fff', letterSpacing: '0.08em',
          }}>
            {ukiyoKanji[step] || ukiyoKanji[0]}
          </span>
        </div>
        <div style={{ border: '1.5px solid #1A1410', padding: '3px 9px', background: '#EDE4CC' }}>
          <span style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 10,
            fontWeight: 600, color: '#1A1410', letterSpacing: '0.12em', textTransform: 'uppercase',
          }}>
            {ukiyoLabels[step] || ukiyoLabels[0]}
          </span>
        </div>
      </div>
    );
  }

  return (
    <p className="text-xs font-semibold tracking-[0.15em] uppercase text-primary-600 dark:text-primary-400 mb-1">
      {standardLabels[step] || standardLabels[0]}
    </p>
  );
}
